<template>
  <div class="white">
    <actionbar v-bind:select="true" v-bind:modify="true" v-on:select="select" v-on:modify="modify"></actionbar>

    <tablepage
      ref="tableref"
      id="tableref"
      v-on:created="tableCreated"
      v-on:currentPage="currentPage"
      v-on:currentRow="currentRow"
      :cols="cols"
      :items="items"
      :total="total"
      :perpage="count"
    ></tablepage>
    <b-modal
      ref="modallg"
      size="lg"
      v-bind:title="title"
      hide-footer
      class="ksmodal"
      header-bg-variant="success"
      body-text-variant="dark"
    >
      <b-tabs>
        <b-tab :title="$t('倾斜检测')">
          <alarmAction :car="false" :alarm="false" :value="modalData.ang" :filter="true"></alarmAction>
          <hr />
        </b-tab>
        <b-tab :title="$t('漏电检测')">
          <alarmAction :car="false" :alarm="false" :value="modalData.leakel" :filter="true"></alarmAction>
          <hr />
        </b-tab>
      </b-tabs>
    </b-modal>
    <deletedata
      ref="del"
      v-on:deleted="deleted"
      :sid="sid"
      url="/api/device/DelWaterLevel"
      :title="$t('删除')"
    ></deletedata>
  </div>
</template>

<script>
import actionbar from "@/components/actionbar";
import tablepage from "@/components/tablepage";
import modify from "@/components/modify";
import deletedata from "@/components/deletedata";
import alarmAction from "@/components/alarmAction";
import { Link } from "@/assets/utils/datef";
export default {
  components: { actionbar, tablepage, modify, deletedata, alarmAction },
  data: function() {
    return {
      radio: 0,
      title: this.$t("修改"),
      modalData: this.resetData(),
      loading: {},
      cols: [
        { name: this.$t("设备名"), value: "StandName" },
        {
          name: this.$t("设备类型"),
          value: "TypeName",
          subvalue: "DeviceType"
        },
        {
          name: this.$t("设备型号"),
          value: "ModelNumber",
          subvalue: "DeviceType"
        },
        { name: this.$t("倾斜检测"), value: "State", subvalue: "ang" },
        { name: this.$t("漏电检测"), value: "State", subvalue: "leakel" },
      ],
      items: [],
      total: 0,
      count: 10,
      index: 0,
      sid: "",
      labels: this.getResetLable(),
      current: null,
      link: Link().filter(function(x) {
        return x.state == 1;
      }),
      selfChoose: {
        radio: null,
        devs: [],
        selected: {}
      },
      flagChoose: {
        radio: null,
        devs: [],
        selected: {}
      },
      leds: []
    };
  },
  methods: {
    select(noloading, index) {
      if (!noloading) {
        if (!index) {
          this.index = 0;
        }
        this.loading = this.$loading({ fullScreen: true });
      }
      new Promise((res, rej) => {
        let obj = {
          Index: this.index,
          Count: this.count
        };
        this.$ksajax
          .ksPostPromise("/api/asset/GetLampStands", obj, true)
          .then(data => {
            data.Items.forEach(x => {
              x.url=`http://${x.Ip}`
              x.leakel = {
                State: "关闭",
                LinkageActions: []
              };
              x.ang={
                State: "关闭",
                LinkageActions: []
              };
            });
            this.items = data.Items;
            this.total = data.TotalCount;
            res();
          })
          .catch(err => {
            rej(err);
          });
      })
        .then(() => {
          return new Promise((res, rej) => {
            let obj = {
              Index: this.index,
              Count: 1000,
              DevCtgSid: "099"
            };
            this.$ksajax
              .ksPostPromise("/api/device/GetSensorLinkages", obj, true)
              .then(data => {
                this.items.forEach(x => {
                  data.Items.forEach(y => {
                    if (y.LinkageActions) {
                      y.LinkageActions.forEach(l => {
                        l.link = this.link.find(o => o.value == l.LinkageType);
                        l.guid = this.guid();
                      });
                    }
                    if (y.DeviceSid == x.DeviceSid) {
                      if (y.DataKind == 123) {
                        y.State = y.IsEnabled == 0 ? "关闭" : "开启";
                        x.leakel = y;
                      }
                      if (y.DataKind == 67) {
                        y.State = y.IsEnabled == 0 ? "关闭" : "开启";
                        x.ang = y;
                      }
                    }
                  });
                });
                res();
              })
              .catch(err => {
                rej(err);
              });
          });
        })
        .then(() => {
          if (this.loading.close) {
            this.loading.close();
          }
        })
        .catch(err => {
          this.$throw(err);
          if (this.loading.close) {
            this.loading.close();
          }
        });
    },
    guid() {
      var guid = "";
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16);
        guid += n;
        if (i == 8 || i == 12 || i == 16 || i == 20) guid += "-";
      }
      return guid;
    },
    del() {
      if (this.current == null) {
        throw this.$t("选择一条数据");
      }
      this.sid = this.current.Sid;
      this.$refs.ksmodel.show();
    },
    modify() {
      if (this.current == null) {
        throw this.$t("选择一条数据");
      }
      this.modalData.leakel = {
        Sid: this.current.leakel ? this.current.leakel.Sid : null,
        LinkageName: "漏电检测",
        IsEnabled: this.current.leakel ? this.current.leakel.IsEnabled : false,
        DeviceSid: this.current.DeviceSid,
        DataKind: 123,
        ThresholdValue: 5,
        CompareSymbol: this.current.leakel
          ? this.current.leakel.CompareSymbol
          : 0,
        LinkageActions: this.current.leakel
          ? this.current.leakel.LinkageActions
          : [],
        IsContrary: this.current.leakel ? this.current.leakel.IsContrary : false
      };
      
      this.modalData.ang = {
        Sid: this.current.ang ? this.current.ang.Sid : null,
        LinkageName: "倾斜检测",
        IsEnabled: this.current.ang ? this.current.ang.IsEnabled : false,
        DeviceSid: this.current.DeviceSid,
        DataKind: 67,
        ThresholdValue: 5,
        CompareSymbol: this.current.ang
          ? this.current.ang.CompareSymbol
          : 0,
        LinkageActions: this.current.ang
          ? this.current.ang.LinkageActions
          : [],
        IsContrary: this.current.ang ? this.current.ang.IsContrary : false
      };
      this.$refs.modallg.show();
    },
    tableCreated() {},
    currentPage(val) {
      this.index = (val - 1) * this.count;
      this.select();
    },
    currentRow(val) {
      this.current = val;
    },
    resetData() {
      return {
        ang: { LinkageActions: [] },
        leakel: { LinkageActions: [] },
      };
    },
    getResetLable() {
      return [
        {
          label: this.$t("设备名"),
          type: "text",
          value: "DeviceName",
          require: true
        },
        {
          label: this.$t("序号"),
          type: "text",
          value: "Serial",
          require: true
        },
        {
          label: this.$t("类型"),
          type: "select",
          value: "DTypeSid",
          require: true,
          bind: this.$store.getters.getDeviceType("009")
        },
        {
          label: this.$t("位置"),
          type: "map",
          value: "Address",
          require: true
        },
        {
          label: this.$t("量程"),
          type: "number",
          value: "MeasuringRange",
          require: true,
          defalut: 9000
        },
        {
          label: this.$t("基值"),
          type: "number",
          value: "BasicValue",
          require: true,
          defalut: 3
        },
        {
          label: this.$t("单位量"),
          type: "number",
          value: "UnitAmount",
          require: true,
          defalut: 3000
        }
      ];
    },
    submited() {
      this.select();
    },
    deleted() {
      this.select();
    },
    onSubmit(evt) {
      evt.preventDefault();
    },
    addItem(val) {
      if (val == 0) {
        //self
        var dev = this.selfChoose.devs.find(
          x => x.Sid == this.selfChoose.selected
        );
        var action = this.link.find(x => x.value == this.selfChoose.radio);
        this.modalData.self.LinkageActions.push({
          Sid: "",
          DeviceSid: dev.Sid,
          DeviceName: dev.DeviceName,
          LinkageType: action.value,
          Content: null,
          link: action
        });
      }
    },
    selfChange(val) {
      if ([0, 1, 2, 3, 4].indexOf(val) != -1) {
        if (this.leds.length == 0) {
          let obj = {
            Index: 0,
            Count: 1000
          };
          this.loading = this.$loading();
          this.$ksajax
            .ksPostPromise("/api/device/GetDeviceLedAds", obj, true)
            .then(x => {
              this.leds = x.Items;
              this.selfChoose.devs = x.Items;
              this.selfChoose.selected = this.leds[0].Sid;
              this.loading.close();
            })
            .catch(err => {
              this.$throw(err);
              this.loading.close();
            });
        } else {
          this.selfChoose.devs = this.leds;
          this.selfChoose.selected = this.leds[0].Sid;
        }
      }
    }
  },
  mounted: function() {
      this.$nextTick(()=>{
          this.select();
      })
  }
};
</script>
